


















import {Stored} from "vue-stored-prop-decorator";
import {Prop} from "vue-property-decorator";
import {Component} from '@/shared/component';
import {AbstractSearchVue} from '@/components/Abstract/AbstractSearchVue';

import InputSearchEntity from '@/components/Input/SearchEntity.vue';
import CrudFournisseurFilterReduce from '@/components/Crud/Fournisseur/FilterReduce.vue';
import CrudFournisseurListForSelect from '@/components/Crud/Fournisseur/ListForSelect.vue';
import storeFournisseur, {FournisseurFilter} from "@/stores/modules/fournisseur";

@Component({
	components: {
		CrudFournisseurFilterReduce,
		CrudFournisseurListForSelect,
		InputSearchEntity,
	}
})
export default class CrudFournisseurSearch extends AbstractSearchVue {
	//private type: FournisseurType = null;

	@Stored(() => storeFournisseur) filters: FournisseurFilter;

	private filterComponent = CrudFournisseurFilterReduce;
	private listComponent = CrudFournisseurListForSelect;

	private async setFilters(): Promise<void> {
		await this.$nextTick();
	}
}
